import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

const testimonials = [
  {
    name: 'Mehmet Yılmaz',
    location: 'Nilüfer, Bursa',
    rating: 5,
    text: 'Bioklimatik pergola montajımızı Bursa Tente yaptı. Hem kalitesi hem de fiyatı çok uygundu. Bahçemiz tam bir yaşam alanına dönüştü. Ekip son derece profesyonel ve işlerini titizlikle yapıyorlar. Tüm komşularıma tavsiye ettim.',
    image: 'https://public.readdy.ai/ai/img_res/e7f90dbefd075d598b4ba08cf40c4009.jpg',
  },
  {
    name: 'Ayşe Demir',
    location: 'Osmangazi, Bursa',
    rating: 5,
    text: 'Körüklü tente için araştırırken Bursa Tente ile tanıştık. Ürün kalitesi ve montaj hizmeti harika. Balkonumuz artık her mevsim kullanılabilir hale geldi. Keşke daha önce yapsaydık. Kesinlikle tavsiye ediyorum.',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20happy%20Turkish%20woman%20homeowner%20on%20balcony%2C%20satisfied%20customer%20smiling%20warmly%2C%20residential%20setting%2C%20genuine%20positive%20emotion%2C%20testimonial%20style%20photography%2C%20simple%20background&width=400&height=400&seq=test2&orientation=squarish',
  },
  {
    name: 'Ahmet Kaya',
    location: 'Yıldırım, Bursa',
    rating: 5,
    text: 'Cafe için otomatik pergola sistemini tercih ettik. Müşterilerimiz çok memnun. Hava durumuna göre ayarlanabiliyor ve çok pratik. Yatırımın karşılığını fazlasıyla aldık. Bursa Tente ekibine teşekkürler.',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20successful%20Turkish%20cafe%20owner%20standing%20in%20front%20of%20outdoor%20terrace%2C%20proud%20business%20owner%20smiling%2C%20commercial%20setting%2C%20professional%20testimonial%20photography%2C%20simple%20background&width=400&height=400&seq=test3&orientation=squarish',
  },
  {
    name: 'Fatma Özdemir',
    location: 'Mudanya, Bursa',
    rating: 5,
    text: 'Deniz kenarındaki evimize zip perde sistemi yaptırdık. Rüzgar çok olmasına rağmen hiç sorun yaşamadık. Manzaramızı kapatmadan koruması harika. Ekip çok deneyimli, işini biliyor. Çok memnunuz.',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20elegant%20Turkish%20woman%20in%20her%20seaside%20home%2C%20satisfied%20homeowner%20with%20warm%20smile%2C%20coastal%20residential%20setting%2C%20testimonial%20photography%20style%2C%20simple%20background&width=400&height=400&seq=test4&orientation=squarish',
  },
  {
    name: 'Can Arslan',
    location: 'Görükle, Bursa',
    rating: 5,
    text: 'Villama bioklimatik pergola sistemini kurduklarında bahçe tam bir yaşam alanına dönüştü. Lamel sistemi sayesinde istediğim kadar güneş ve hava alabiliyorum. Teknoloji ve estetiğin mükemmel birleşimi. Teşekkürler Bursa Tente.',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20affluent%20Turkish%20homeowner%20in%20luxury%20villa%20setting%2C%20satisfied%20villa%20owner%20smiling%20confidently%2C%20upscale%20residential%20background%2C%20testimonial%20photography%2C%20simple%20background&width=400&height=400&seq=test5&orientation=squarish',
  },
  {
    name: 'Zeynep Türk',
    location: 'Nilüfer, Bursa',
    rating: 5,
    text: 'Restoranımızın terasına mafsallı tente yaptırdık. Hem estetik hem fonksiyonel. Müşterilerimiz açık alanda oturmayı tercih ediyor artık. Montaj çok hızlı oldu ve fiyat gayet makul. Başka bir şube için tekrar çalışacağız.',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20professional%20Turkish%20restaurant%20owner%20woman%20smiling%20warmly%2C%20successful%20business%20owner%20in%20restaurant%20setting%2C%20confident%20expression%2C%20testimonial%20photography%20style%2C%20simple%20background&width=400&height=400&seq=test6&orientation=squarish',
  },
  {
    name: 'Burak Şahin',
    location: 'Osmangazi, Bursa',
    rating: 5,
    text: 'Ev balkonumuz için körüklü tente aldık. Manuel açılıp kapanması çok kolay. Kumaş kalitesi gerçekten iyi, rengi solmadı. İşçilik de çok düzgün. Bursa Tente\'yi seçtiğimiz için çok mutluyuz. Herkese öneririm.',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Turkish%20professional%20man%20at%20home%20balcony%2C%20satisfied%20homeowner%20with%20friendly%20smile%2C%20modern%20residential%20setting%2C%20testimonial%20photography%2C%20simple%20background&width=400&height=400&seq=test7&orientation=squarish',
  },
  {
    name: 'Elif Yıldız',
    location: 'Gürsu, Bursa',
    rating: 5,
    text: 'Şeffaf stor sistemini balkonumuza yaptırdık. Kış aylarında bile balkonumuzda oturabiliyoruz artık. Manzarayı hiç kapatmadan rüzgar ve soğuktan koruyor. Kaliteli malzeme ve profesyonel montaj. Çok teşekkürler.',
    image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20cheerful%20young%20Turkish%20woman%20homeowner%2C%20happy%20customer%20smiling%20genuinely%20at%20home%2C%20cozy%20residential%20interior%2C%20testimonial%20style%20photography%2C%20simple%20background&width=400&height=400&seq=test8&orientation=squarish',
  },
];

export default function Testimonials() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  const openLightbox = (imageSrc: string) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-24 md:pt-32 pb-12 md:pb-20">
        <div className="max-w-[1400px] mx-auto px-6">
          <header className="mb-16 text-center">
            <h1 className="text-5xl font-bold text-primary mb-4">Müşteri Yorumları</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Bursa genelinde binlerce mutlu müşterimizin görüşleri
            </p>
          </header>

          <section className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-20">
            {testimonials.map((testimonial, index) => (
              <article
                key={index}
                className="bg-white rounded-2xl p-6 md:p-8 shadow-md hover:shadow-xl transition-shadow"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-primary rounded-full flex items-center justify-center text-white text-xl md:text-2xl font-bold flex-shrink-0">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <h2 className="text-lg font-bold text-primary">{testimonial.name}</h2>
                    <p className="text-sm text-gray-600">{testimonial.location}</p>
                  </div>
                </div>

                <div className="flex gap-1 text-yellow-400 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>

                <p className="text-gray-700 leading-relaxed">"{testimonial.text}"</p>
              </article>
            ))}
          </section>

          <section className="mt-20 bg-primary text-white rounded-2xl p-12 text-center">
            <h2 className="text-4xl font-bold mb-6">Siz de Aramıza Katılın</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Binlerce mutlu müşterimizin deneyimini siz de yaşayın
            </p>
            <a
              href="https://wa.me/905421821925?text=Merhaba,%20tente%20hakkında%20bilgi%20almak%20istiyorum"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white text-primary px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              Hemen Teklif Alın
            </a>
          </section>

          <section className="grid md:grid-cols-3 gap-6 md:gap-8">
            {[1, 2, 3].map((num) => (
              <div
                key={num}
                className="relative rounded-2xl overflow-hidden shadow-lg h-64 md:h-80 cursor-pointer"
                onClick={() => openLightbox(`https://readdy.ai/api/search-image?query=Modern%20luxury%20outdoor%20living%20space%20with%20elegant%20pergola%20and%20awning%20systems%2C%20satisfied%20customer%20enjoying%20shaded%20terrace%2C%20comfortable%20lifestyle%20photography%2C%20high%20quality%20residential%20installation%2C%20professional%20craftsmanship%2C%20natural%20warm%20lighting&width=600&height=800&seq=testgal${num}&orientation=portrait`)}
              >
                <img
                  src={`https://readdy.ai/api/search-image?query=Modern%20luxury%20outdoor%20living%20space%20with%20elegant%20pergola%20and%20awning%20systems%2C%20satisfied%20customer%20enjoying%20shaded%20terrace%2C%20comfortable%20lifestyle%20photography%2C%20high%20quality%20residential%20installation%2C%20professional%20craftsmanship%2C%20natural%20warm%20lighting&width=600&height=800&seq=testgal${num}&orientation=portrait`}
                  alt={`Bursa Tente Referans Proje ${num}`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </section>
        </div>
      </main>

      <Footer />
      <CookieBanner />

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 cursor-pointer"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors"
            onClick={closeLightbox}
            aria-label="Kapat"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Büyütülmüş görsel"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}